export default __webpack_public_path__ + "static/3-b1148839c9d97bf89cb28622bf043edd.webp";